import React, {useEffect, useState} from 'react';
import classes from "./bonuses.module.css";
import {texts} from "../../../../translate";
import bonus1 from '../../../../images/bonus1.png'
import bonus2 from '../../../../images/bonus2.png'
import bonus3 from '../../../../images/bonus3.png'
import Timer from "../timer/timer";
import Button from "../button/button";
import {CSSTransition} from "react-transition-group";
import {getPresaleProjects} from "../../../../utils/api";
import {useTelegram} from "../../../../hooks/useTelegram";

const IMAGES = {bonus1, bonus2, bonus3}
const STAGE_KEYS = {idea: 0, spec: 1, mvp: 2, legal: 3, presale: 4, round: 4}

const fallbackProjects = () => ([
    {id: 'wallet', title: 'Крипто-кошелёк', title_en: 'Crypto wallet', description: 'Проект кошелька экосистемы. Ранний доступ для участников Lion Launch.', description_en: 'Ecosystem wallet project. Early access for Lion Launch members.', badge: 'Ранний доступ', image_key: 'bonus1', stage: 'mvp', stage_index: 2, timer_enabled: false, round_open: false, round_price: '', ends_at: null, presale_url: null},
    {id: 'exchange', title: 'Крипто-биржа', title_en: 'Crypto exchange', description: 'Биржа экосистемы. Закрытый первый раунд для участников.', description_en: 'Ecosystem exchange. Closed first round for members.', badge: 'Закрытый раунд', image_key: 'bonus2', stage: 'spec', stage_index: 1, timer_enabled: false, round_open: false, round_price: '[0,005 $]', ends_at: null, presale_url: null},
    {id: 'organizer', title: 'Органайзер мотиватор', title_en: 'Motivator organizer', description: 'Органайзер с искусственным интеллектом. Для участников — 1$ вместо 50$.', description_en: 'AI organizer. Members pay $1 instead of $50.', badge: '1$ вместо 50$', image_key: 'bonus3', stage: 'mvp', stage_index: 2, timer_enabled: false, round_open: false, round_price: '', ends_at: null, presale_url: null},
])

const stageLabel = (item, lang) => {
    const stages = texts[lang].presale.stages
    const index = item.stage_index ?? STAGE_KEYS[item.stage] ?? 2
    if (item.round_open) return lang === 'ru' ? 'Окно открыто' : 'Window open'
    return `${lang === 'ru' ? 'Стадия' : 'Stage'}: ${stages[index] || stages[2]}`
}

const CloseIcon = ({onClick}) => (
    <svg className={classes.close} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M35 20C35 21.9698 34.612 23.9204 33.8582 25.7403C33.1044 27.5601 31.9995 29.2137 30.6066 30.6066C29.2137 31.9995 27.5601 33.1044 25.7403 33.8582C23.9204 34.612 21.9698 35 20 35C18.0302 35 16.0796 34.612 14.2597 33.8582C12.4399 33.1044 10.7863 31.9995 9.3934 30.6066C8.00052 29.2137 6.89563 27.5601 6.14181 25.7403C5.38799 23.9204 5 21.9698 5 20C5 16.0218 6.58035 12.2064 9.3934 9.3934C12.2064 6.58035 16.0218 5 20 5C23.9782 5 27.7936 6.58035 30.6066 9.3934C33.4196 12.2064 35 16.0218 35 20ZM12.155 27.845C11.8425 27.5325 11.667 27.1086 11.667 26.6667C11.667 26.2247 11.8425 25.8009 12.155 25.4883L17.6433 20L12.155 14.5117C11.8514 14.1973 11.6834 13.7763 11.6872 13.3393C11.691 12.9023 11.8663 12.4843 12.1753 12.1753C12.4843 11.8663 12.9023 11.691 13.3393 11.6872C13.7763 11.6834 14.1973 11.8514 14.5117 12.155L20 17.6433L25.4883 12.155C25.6421 11.9958 25.826 11.8688 26.0293 11.7815C26.2327 11.6941 26.4514 11.6482 26.6727 11.6462C26.894 11.6443 27.1134 11.6865 27.3183 11.7703C27.5231 11.8541 27.7092 11.9779 27.8657 12.1343C28.0221 12.2908 28.1459 12.4769 28.2297 12.6817C28.3135 12.8866 28.3557 13.106 28.3538 13.3273C28.3518 13.5486 28.3058 13.7673 28.2185 13.9707C28.1312 14.174 28.0042 14.3579 27.845 14.5117L22.3567 20L27.845 25.4883C28.1486 25.8027 28.3166 26.2237 28.3128 26.6607C28.309 27.0977 28.1337 27.5157 27.8247 27.8247C27.5157 28.1337 27.0977 28.309 26.6607 28.3128C26.2237 28.3166 25.8027 28.1486 25.4883 27.845L20 22.3567L14.5117 27.845C14.1991 28.1575 13.7753 28.333 13.3333 28.333C12.8914 28.333 12.4675 28.1575 12.155 27.845Z" fill="#4C4F55"/>
    </svg>
)

const Bonuses = ({lang, isActive, limit = 0, onLimit}) => {
    const {openExternal} = useTelegram()
    const [openMenu, setOpenMenu] = useState(null)
    const [projects, setProjects] = useState([])

    useEffect(() => {
        const load = async () => {
            try {
                const res = await getPresaleProjects()
                if (Array.isArray(res) && res.length) {
                    setProjects(res)
                } else {
                    setProjects(fallbackProjects())
                }
            } catch {
                setProjects(fallbackProjects())
            }
        }
        load()
    }, [])

    const openUrl = (url) => openExternal(url)

    const project = projects.find((item) => item.id === openMenu)
    const title = lang === 'ru' ? project?.title : project?.title_en
    const description = lang === 'ru' ? project?.description : project?.description_en
    const image = IMAGES[project?.image_key] || bonus1
    const stageIndex = project?.stage_index ?? STAGE_KEYS[project?.stage] ?? 2
    const overlayOpen = Boolean(openMenu)
    const stages = texts[lang].presale.stages

    return (
        <div className={classes._}>
            <div className={classes.header}>{texts[lang].bonuses.bonus}</div>
            <div className={`${classes.blocks} ${projects.length > 3 ? classes.blocksScroll : ''}`}>
                {projects.map((item) => {
                    const locked = !isActive
                    return (
                        <div
                            key={item.id}
                            className={`${classes.block1} ${locked ? classes.locked : ''} ${item.round_open ? classes.roundOpen : ''}`}
                            onClick={() => { if (!locked) setOpenMenu(item.id) }}
                        >
                            {locked && <div className={classes.lock}>🔒</div>}
                            <img className={classes.img} src={IMAGES[item.image_key] || bonus1} alt={''}/>
                            <div className={classes.block1Text}>{lang === 'ru' ? item.title : item.title_en}</div>
                            <div className={classes.block1Text2}>{item.badge}</div>
                            <div className={classes.stageLine}>{stageLabel(item, lang)}</div>
                            {item.timer_enabled && item.ends_at ? (
                                <Timer lang={lang} time={new Date(item.ends_at).getTime()}/>
                            ) : null}
                        </div>
                    )
                })}
            </div>
            <div>
                <CSSTransition in={overlayOpen} timeout={500} classNames="openBonusFon" unmountOnExit>
                    <div className={classes.fon} onClick={()=>setOpenMenu(null)}></div>
                </CSSTransition>
                <CSSTransition in={Boolean(project)} timeout={500} classNames="openBonusMenu" unmountOnExit>
                    <div className={classes.menu}>
                        <div className={classes.closeBlock}>
                            <CloseIcon onClick={()=>setOpenMenu(null)}/>
                        </div>
                        <img className={classes.img2} src={image} alt={''}/>
                        <div className={classes.menuText1}>{title}</div>
                        <div className={classes.menuText2}>{description}</div>
                        <div className={classes.stages}>
                            {stages.map((name, index) => (
                                <div key={name} className={`${classes.stage} ${index <= stageIndex ? classes.stageOn : ''}`}>
                                    <div className={classes.stageBar}/>
                                    <span>{name}</span>
                                </div>
                            ))}
                        </div>
                        <div className={classes.meta}>
                            {project?.round_price ? (
                                <div className={classes.metaRow}>
                                    <div className={classes.metaLabel}>{texts[lang].presale.price}</div>
                                    <div className={classes.metaValue}>{project.round_price}</div>
                                </div>
                            ) : null}
                            <div className={classes.metaRow}>
                                <div className={classes.metaLabel}>{texts[lang].presale.limit}</div>
                                <div className={classes.metaValue}>{Number(limit || 0).toLocaleString('ru-RU')}</div>
                            </div>
                            <div className={classes.metaRow}>
                                <div className={classes.metaLabel}>{texts[lang].presale.queue}</div>
                                <div className={classes.metaValue}>{lang === 'ru' ? '2-е окно' : '2nd window'}</div>
                            </div>
                        </div>
                        <div className={classes.timerHint}>
                            {project?.timer_enabled && project?.ends_at ? (
                                <Timer lang={lang} bonus={true} time={new Date(project.ends_at).getTime()}/>
                            ) : (
                                <>
                                    <div className={classes.presaleLabel}>{texts[lang].presale.soon}</div>
                                    <div className={classes.menuText2}>{texts[lang].presale.dateHint}</div>
                                </>
                            )}
                        </div>
                        <div className={classes.menuButtons}>
                            {project?.round_open && project?.presale_url ? (
                                <Button click={() => openUrl(project.presale_url)} active={true}>
                                    {texts[lang].presale.open}
                                </Button>
                            ) : (
                                <Button click={() => { setOpenMenu(null); onLimit?.() }} active={true}>
                                    {texts[lang].button.text2}
                                </Button>
                            )}
                        </div>
                        <p className={classes.risk}>
                            {texts[lang].presale.risk}{' '}
                            <span onClick={() => openUrl('https://alderwayne.group')}>{texts[lang].presale.developer}</span>
                        </p>
                    </div>
                </CSSTransition>
            </div>
        </div>
    );
};

export default Bonuses;
